// @mui
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import { GetVisitByIdOriginEnum } from 'woofwoof-api';
// ----------------------------------------------------------------------

interface VisitWalkInBadgeProps {
  origin?: GetVisitByIdOriginEnum | null;
}

/**
 * `origin` is nullable: visits booked before the field existed carry null,
 * which means "unknown" — never "owner". So only an explicit WALK_IN is marked
 * and every other value, known or missing alike, renders nothing rather than
 * asserting a booking channel nobody recorded.
 */
export default function VisitWalkInBadge({
  origin,
}: VisitWalkInBadgeProps): JSX.Element | null {
  const { t } = useTranslation();

  if (origin !== GetVisitByIdOriginEnum.WalkIn) {
    return null;
  }

  return (
    <Tooltip title={String(t('visit.walkInBadgeTooltip'))}>
      <Label
        variant="soft"
        color="info"
        sx={{ textTransform: 'none', width: 'fit-content' }}
        startIcon={<Iconify icon="mdi:walk" />}
        data-testid="visit-walk-in-badge"
      >
        {t('visit.walkInBadge')}
      </Label>
    </Tooltip>
  );
}
